// Brand-masking for AI model identifiers.
// The platform's AI is sold as "SYLink AI" — the underlying model name must never
// be shown to users. Use maskAIModel() to scrub any model identifier from text that
// is rendered in the UI (labels, dropdown options, loaded-model lists, etc.).
export const maskAIModel = (s) =>
  String(s ?? '').replace(
    /\b(glm-?5(?:\.\d+)?(?::cloud)?|qwen[\w.:-]*|sylink\/sylink:\d+b|deepseek\S*|llama[\d.]+\S*|mistral\S*|gemma\S*)\b/gi,
    'SYLink AI'
  );

export default maskAIModel;
